import { orderMessagesUrl } from './resources'
import { HubConnectionBuilder, HttpTransportType }  from '@aspnet/signalr'
import store from '../store/index.js'

let hubConnection;
let isConnected = false;
//
//Establish a hub to connect to server
//
function createHubConnection(token) {
    hubConnection = new HubConnectionBuilder() 
                            .withUrl(orderMessagesUrl, {
                                skipNegotiation: true,
                                transport: HttpTransportType.WebSockets,
                                accessTokenFactory: () => token
                            })
                            .build();
}
//
//Connect to server
//
async function connectToServer() {
    let count = 0;
    while (!isConnected && count < 10 ) {
        await setTimeout( () => { console.log('Connecting...') }, 100*1000000 );
        count++;
        await hubConnection.start()
             .then(() => {
                    console.log('Connection Started');
                    isConnected = true; })
             .catch((err) => {
                    console.log('Cannot connect to server!');
                    console.log(err);
                });
    }
    
}
//
//Listening for specific method that the server will send to client
//
async function registerToServerEvent(serverevent) {
    if (isConnected) {
        await hubConnection.on(serverevent, 
            (order) => { 
                            store.commit('orderscontrol/addNewOrderByRestaurantState', order); }); 
    }
    
}
//
//Register to group: Each restaurant is a group that restaurant owner and restaurant manager
//must register to to receive order messages from customer
//
async function registerToGroup(restaurantid) {
    if (isConnected) {
        await hubConnection.invoke('AddToGroup', restaurantid)
                            .then(console.log('Client is registered to group'))
                            .catch(err => console.log(err));
    }
    
    
}

async function unregisterFromGroup(restaurantid) {
    if (isConnected) {
        await hubConnection.invoke('RemoveFromGroup', restaurantid)
                            .then(console.log('Client is unregistered to group'))
                            .catch(err => console.log(err));
    }
    
}

export default {
    name: 'ordermessages',
    createHubConnection,
    connectToServer,
    registerToServerEvent,
    registerToGroup,
    unregisterFromGroup,
} 
